// source: src/common/setting/app/feature/reporting_options.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.loupe.common.setting.feature.FilterFieldOption', null, global);
goog.exportSymbol('proto.loupe.common.setting.feature.ReportingOptionsSetting', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.setting.feature.ReportingOptionsSetting.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.setting.feature.ReportingOptionsSetting, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.setting.feature.ReportingOptionsSetting.displayName = 'proto.loupe.common.setting.feature.ReportingOptionsSetting';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.setting.feature.FilterFieldOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.setting.feature.FilterFieldOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.setting.feature.FilterFieldOption.displayName = 'proto.loupe.common.setting.feature.FilterFieldOption';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.setting.feature.ReportingOptionsSetting.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.setting.feature.ReportingOptionsSetting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.toObject = function(includeInstance, msg) {
  var f, obj = {
    dateRangeOptionsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    groupByOptionsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    filterFieldOptionsList: jspb.Message.toObjectList(msg.getFilterFieldOptionsList(),
    proto.loupe.common.setting.feature.FilterFieldOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.setting.feature.ReportingOptionsSetting;
  return proto.loupe.common.setting.feature.ReportingOptionsSetting.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.setting.feature.ReportingOptionsSetting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addDateRangeOptions(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addGroupByOptions(value);
      break;
    case 3:
      var value = new proto.loupe.common.setting.feature.FilterFieldOption;
      reader.readMessage(value,proto.loupe.common.setting.feature.FilterFieldOption.deserializeBinaryFromReader);
      msg.addFilterFieldOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.setting.feature.ReportingOptionsSetting.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.setting.feature.ReportingOptionsSetting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDateRangeOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getGroupByOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getFilterFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.loupe.common.setting.feature.FilterFieldOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string date_range_options = 1;
 * @return {!Array<string>}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.getDateRangeOptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.setDateRangeOptionsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.addDateRangeOptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.clearDateRangeOptionsList = function() {
  return this.setDateRangeOptionsList([]);
};


/**
 * repeated string group_by_options = 2;
 * @return {!Array<string>}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.getGroupByOptionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.setGroupByOptionsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.addGroupByOptions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.clearGroupByOptionsList = function() {
  return this.setGroupByOptionsList([]);
};


/**
 * repeated FilterFieldOption filter_field_options = 3;
 * @return {!Array<!proto.loupe.common.setting.feature.FilterFieldOption>}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.getFilterFieldOptionsList = function() {
  return /** @type{!Array<!proto.loupe.common.setting.feature.FilterFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.loupe.common.setting.feature.FilterFieldOption, 3));
};


/**
 * @param {!Array<!proto.loupe.common.setting.feature.FilterFieldOption>} value
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
*/
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.setFilterFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.loupe.common.setting.feature.FilterFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption}
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.addFilterFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.loupe.common.setting.feature.FilterFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.setting.feature.ReportingOptionsSetting} returns this
 */
proto.loupe.common.setting.feature.ReportingOptionsSetting.prototype.clearFilterFieldOptionsList = function() {
  return this.setFilterFieldOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.setting.feature.FilterFieldOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.setting.feature.FilterFieldOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.setting.feature.FilterFieldOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    field: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fieldType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    delimiter: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption}
 */
proto.loupe.common.setting.feature.FilterFieldOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.setting.feature.FilterFieldOption;
  return proto.loupe.common.setting.feature.FilterFieldOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.setting.feature.FilterFieldOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption}
 */
proto.loupe.common.setting.feature.FilterFieldOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setField(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDelimiter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.setting.feature.FilterFieldOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.setting.feature.FilterFieldOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.setting.feature.FilterFieldOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getField();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFieldType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDelimiter();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string field = 1;
 * @return {string}
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.getField = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption} returns this
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.setField = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption} returns this
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string field_type = 3;
 * @return {string}
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.getFieldType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption} returns this
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.setFieldType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string delimiter = 4;
 * @return {string}
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.getDelimiter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.setting.feature.FilterFieldOption} returns this
 */
proto.loupe.common.setting.feature.FilterFieldOption.prototype.setDelimiter = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


goog.object.extend(exports, proto.loupe.common.setting.feature);
